import React from 'react';

import './StarsRating.scss';

export interface StarsRatingProps {
  /** Number of stars to display */
  stars: number,
  /** Maximum stars to display */
  maxStars: number
}

export function StarsRating(props: StarsRatingProps) {

  let output = []
  if(props.stars >= 0) {
    for (let index = 0; index < props.maxStars; index++) { 
      if (index < props.stars) {
        output.push(<span key={index} className="star-rating-active" >★</span>);
      } else {
        output.push(<span key={index}>★</span>);
      }
      
    }
  }
  else {
    output.push(<span className="no-rating">N/A</span>);
  }

  return (
    <div className="star-rating">
      { output }
    </div>
  )
}

StarsRating.defaultProps = {
  stars: 0,
  maxStars: 5  
}
